import styled from "styled-components";

const Container = styled.div`
  flex-wrap: wrap;
  margin-bottom: 10px;

  .MuiButton-root.filter {
    margin-bottom: 35px;
    width: 130px;
  }

  .MuiOutlinedInput-root.search {
    position: absolute;
    right: 0;
    height: 35px;
  }

  .MuiOutlinedInput-root.search.above-filter {
    top: -30px;
  }
`;

export { Container };
